import { useState } from "react";
import { saveFundsCenterDetails } from "../Api/FundsCenter";
import { Container, Form, Button, Row, Col } from "react-bootstrap";

import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

const FundsCenter = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId; 

  const [fundsData, setFundsData] = useState({
    code: "",
    name: "",
    stpl: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFundsData({
      ...fundsData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveFundsCenterDetails(fundsData, userId);
      toast.success(`🦄 Funds Center Added Successfully`);
      setFundsData({
        code: "",
        name: "",
        stpl: ""
      });
    } catch (error) {
      toast.error(`🦄 Error: ${error.message || "Failed to save funds center details"}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="fields-container">
            <h2 className="fields-title">Funds Center</h2>

            <Form onSubmit={handleSubmit} className="fields-form">
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Code <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="code"
                      value={fundsData.code}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Name <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={fundsData.name}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>STPL <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="stpl"
                      value={fundsData.stpl}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              <div className="fields-btn-container">
                <Button variant="primary" type="submit" className="fields-submit">
                  Save Funds Center
                </Button>
              </div>
            </Form>
          </Container>
        </div>
      

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default FundsCenter;